import PageList from '#/modules/commonComponents/PageList';
import storePlaceMgmtNavigate from '#/modules/infra/navigation/storePlaceMgmtNavigate';

const StorePlaceHubPage = () => {
  return <PageList title="倉別管理" linkList={storePlaceMgmtNavigate} />;
};

export default StorePlaceHubPage;
